import { http } from "../http-common";

const FetchLoggedinUserId = (principalName) => {
  return http.get(
    `/user-management/logged-in-user?userPrincipalName=${principalName} `
  );
};

const FetchUserFunctionalityList = (id,page,pageSize) => {
  return http.get(
    `/role-functionality-management?pageNumber=${page}&pageSize=${pageSize}`
  );
};
const FetchUserFunctionalityRoleTracks = () => {
  return http.get(
    `/role-functionality-management/functionalities`
  );
};
const PostUserFunctionalityMapModules = (data) => {
  return http.post(
    `/role-functionality-management/map-functionalities`,data
  );
};
const getActiveRulesList = () => {
  return http.get(`/conflict-indicator?status=true`);
};

const UserFunctionalityService = {
  FetchUserFunctionalityList,
  FetchUserFunctionalityRoleTracks,
  PostUserFunctionalityMapModules,
  getActiveRulesList

};

export default UserFunctionalityService;

